import styled from 'styled-components';
import {
  HappierFaceWithBorder,
  HappiestFaceWithBorder,
  HappyFaceWithBorder,
  NeutralFaceWithBorder,
  SadderFaceWithBorder,
  SaddestFaceWithBorder,
  SadFaceWithBorder,
} from 'icons';

import { Moods } from '../../Track/Moods/types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const SaddestIcon = styled<any>(SaddestFaceWithBorder).attrs(
  ({ theme }) => ({
    primaryColor: theme.colors.mood.saddest,
    secondaryColor: theme.colors.mood.border,
    role: 'img',
    'aria-label': 'Saddest',
  }),
)``;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const SadderIcon = styled<any>(SadderFaceWithBorder).attrs(
  ({ theme }) => ({
    primaryColor: theme.colors.mood.sadder,
    secondaryColor: theme.colors.mood.border,
    role: 'img',
    'aria-label': 'Sadder',
  }),
)``;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const SadIcon = styled<any>(SadFaceWithBorder).attrs(({ theme }) => ({
  primaryColor: theme.colors.mood.sad,
  secondaryColor: theme.colors.mood.border,
  role: 'img',
  'aria-label': 'Sad',
}))``;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const NeutralIcon = styled<any>(NeutralFaceWithBorder).attrs(
  ({ theme }) => ({
    primaryColor: theme.colors.mood.neutral,
    secondaryColor: theme.colors.mood.border,
    role: 'img',
    'aria-label': 'Neutral',
  }),
)``;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const HappyIcon = styled<any>(HappyFaceWithBorder).attrs(
  ({ theme }) => ({
    primaryColor: theme.colors.mood.happy,
    secondaryColor: theme.colors.mood.border,
    role: 'img',
    'aria-label': 'Happy',
  }),
)``;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const HappierIcon = styled<any>(HappierFaceWithBorder).attrs(
  ({ theme }) => ({
    primaryColor: theme.colors.mood.happier,
    secondaryColor: theme.colors.mood.border,
    role: 'img',
    'aria-label': 'Happier',
  }),
)``;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const HappiestIcon = styled<any>(HappiestFaceWithBorder).attrs(
  ({ theme }) => ({
    primaryColor: theme.colors.mood.happiest,
    secondaryColor: theme.colors.mood.border,
    role: 'img',
    'aria-label': 'Happiest',
  }),
)``;

export const moodIconMap = {
  [Moods.Saddest]: SaddestIcon,
  [Moods.Sadder]: SadderIcon,
  [Moods.Sad]: SadIcon,
  [Moods.Neutral]: NeutralIcon,
  [Moods.Happy]: HappyIcon,
  [Moods.Happier]: HappierIcon,
  [Moods.Happiest]: HappiestIcon,
};
